<template>
    <div class="section-title-wrapper">
        <Skeletor class="section-title" width="30%" height="27" pill />
        <Skeletor class="dosiin_slider-controls" width="20%" height="27" pill />  
    </div>    
</template>